// apiService.js
import { AssemblyAI } from "assemblyai";
const ASSEMBLYAI_API_KEY = "f30dbb5c85574820927f78ad36cffe7c";
const client = new AssemblyAI({
  apiKey: ASSEMBLYAI_API_KEY,
});

export const getToken = async () => {
  try {
    const response = await fetch(
      "https://mednotes-ai-python.azurewebsites.net/token",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();

    if (data.error) {
      alert(data.error);
      return null;
    }
    return data.token;
  } catch (error) {
    console.error("Error fetching token:", error);
    alert("Failed to fetch token");
    return null;
  }
};

export const uploadFileToServer = async (audioBlob, getAudioSource) => {
  try {
    const formData = new FormData();
    formData.append("file", audioBlob, "file.wav");
    const response = await fetch(
      "https://mednotes-ai-python.azurewebsites.net/upload-file",
      {
        method: "POST",
        body: formData,
      }
    );
    const data = await response.json();
    const audio = data?.blob_url;

    if (audio) {
      getAudioSource(audio);
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    return null;
  }
};

export const transcribeAudio = async (audio) => {
  const params = {
    audio_url: audio,
    speaker_labels: true,
  };
  try {
    const response = await client.transcripts.create(params);
    const transcriptId = response.id;

    let transcriptStatus = "processing";
    while (transcriptStatus === "processing") {
      await new Promise((resolve) => setTimeout(resolve, 5000));
      const statusResponse = await client.transcripts.get(transcriptId);
      transcriptStatus = statusResponse.status;
    }

    if (transcriptStatus === "completed") {
      const transcript = await client.transcripts.get(transcriptId);

      let speakerText = "";
      transcript.utterances.forEach((utterance) => {
        speakerText += `Speaker ${utterance.speaker}: ${utterance.text}\n`;
      });

      return { transcript: transcript.text, speakerTranscript: speakerText };
    } else {
      console.error("Transcription failed");
      return { transcript: "", speakerTranscript: "" };
    }
  } catch (error) {
    console.error("Error during transcription:", error);
    return { transcript: "", speakerTranscript: "" };
  }
};

export const generateReferralLetter = async (data) => {
  try {
    const response = await fetch(
      "https://mednotes-ai-python.azurewebsites.net/generate-letter",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to generate referral letter");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error generating referral letter:", error);
    throw error;
  }
};

export const generateGetDropdown = async (data) => {
  try {
    const response = await fetch(
      "https://mednotes-ai-python.azurewebsites.net/classify_letter",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to generate dropdown data");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error generating dropdown data:", error);
    throw error;
  }
};

export const generateClinicalNotes = async (data) => {
  try {
    const response = await fetch(
      "https://mednotes-ai-python.azurewebsites.net/generate-clinical-notes",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to generate clinical notes");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error generating clinical notes:", error);
    throw error;
  }
};
